import { X } from "lucide-react";

export const SavedPresetTile = ({ preset, active, onApply, onDelete }) => (
    <div
        role="button"
        tabIndex={0}
        onClick={onApply}
        data-testid={`saved-preset-${preset.id}`}
        className={`group relative aspect-square border bg-obsidian overflow-hidden cursor-pointer transition-all duration-200 ${
            active ? "border-blaze ring-1 ring-blaze" : "border-white/10 hover:border-white/40"
        }`}
    >
        <div className="absolute inset-0 flex items-center justify-center">
            <span
                className={`font-display font-bold uppercase text-5xl transition-colors ${
                    active ? "text-blaze/60" : "text-white/15 group-hover:text-white/40"
                }`}
            >
                {preset.label.charAt(0)}
            </span>
        </div>
        <button
            onClick={(e) => {
                e.stopPropagation();
                onDelete();
            }}
            className="absolute top-1.5 right-1.5 w-6 h-6 bg-black/70 border border-white/20 hidden group-hover:flex items-center justify-center hover:bg-blaze hover:border-blaze transition-colors z-10"
            data-testid={`delete-saved-preset-${preset.id}`}
        >
            <X className="w-3 h-3" />
        </button>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent pointer-events-none" />
        <div className="absolute bottom-2 left-2 right-2 text-left pointer-events-none">
            <div className="font-display font-bold uppercase text-sm leading-tight text-white truncate">
                {preset.label}
            </div>
            {active ? (
                <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-blaze mt-1">
                    ● Active
                </div>
            ) : (
                <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-white/30 mt-1">
                    Saved
                </div>
            )}
        </div>
    </div>
);
